export default __webpack_public_path__ + "static/top-app-development-companies-969d636c8cad4397557a7b0c0333904f.png";